export function breakWord(word, until) {
    return word.slice(0, until) + "...";
}
